import { StrictMode } from 'react';
import '@fontsource-variable/inter/index.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import './styles.css';
import { createRoot } from 'react-dom/client';
import { installLayout } from '@forecastify/ui';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app';
import { ErrorBoundary } from './error-boundary';
import { apiBase } from './api';
import { renderStartupFailure } from './startup';

/* ⚠️ Before the first render: base.css's `phone:` and `desktop:` read the attribute this writes. */
installLayout();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

/*
 * ⚠️ **Everything that can fail before the first render is inside this try.**
 *
 * Configuration is still checked before React mounts — a build that does not know where its
 * API is should say so on load rather than on the first request, where it would look like
 * the API being down. What changed is that the refusal now REACHES THE SCREEN: the first
 * version of this file let the check throw, and a missing variable produced a blank white
 * page with the reason visible only in the console.
 */
try {
  apiBase();

  createRoot(root).render(
    <StrictMode>
      {/* ⚠️ `BrowserRouter`, not `HashRouter`. Real paths are what the API's `APP_ORIGIN`-based
          redirect URLs point at — `AUTH_PATHS` are `/auth/callback` and friends, and GoTrue cannot
          send somebody to a fragment. Which means the static host must rewrite unknown paths to
          `index.html`; a deployment that does not is a 404 on every screen but the first. */}
      {/* ⚠️ OUTSIDE the router, so a throw in the router itself is still caught. Inside it, a
          failure in route resolution would take the boundary down with it and the page would go
          white — which is the exact symptom the boundary exists to replace. */}
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  );
} catch (error) {
  renderStartupFailure(root, error);
  throw error;
}
